import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES, COMPONENT_PARALLAX_SPEED } from 'shared/constants';

const propsSchema = [
  {
    key: 'links',
    label: 'Links',
    type: types.ARRAY,
    option: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT
      },
      {
        key: 'bgimage',
        label: 'Background Image (2400 x 1350)',
        type: types.TEXT
      },
      {
        key: 'color_theme',
        label: 'Color Theme',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES
      }
    ]
  },
  {
    key: 'parallax_effect',
    label: 'Parallax Effect',
    type: types.OBJECT,
    option: false,
    children: [
      {
        key: 'enable',
        label: 'Enable',
        type: types.BOOLEAN
      },
      {
        key: 'speed',
        label: 'Speed',
        type: types.ENUM,
        options: COMPONENT_PARALLAX_SPEED
      }
    ]
  }
];

const defaultProps = {
  links: [
    {
      url: '/ff-91',
      label: 'FF 91',
      bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/01_ff91.jpg',
      color_theme: 'DARK'
    },
    {
      url: '/ffzero1',
      label: 'FFZERO1',
      bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/02_ffzero1.jpg',
      color_theme: 'LIGHT'
    },
    {
      url: '/our-company',
      label: 'Our Company',
      bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/03_ourcompany.jpg',
      color_theme: 'DARK'
    },
    {
      url: '/futuresight',
      label: 'FutureSight',
      bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/04_futuresight.jpg',
      color_theme: 'LIGHT'
    }
  ],
  parallax_effect: {
    enable: true,
    speed: 300
  }
};

export default {
  title: 'Billboard',
  id: 'Billboard',
  propsSchema,
  defaultProps
};
